import React from 'react'
import styled from 'styled-components'
import { Grid, Box } from '@mui/material'
import Link from '@mui/material/Link'

import Logo from 'components/assets/Logo'
import ISRILogo from 'components/assets/ISRImem_web.jpg'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import { WhiteTextTypography } from './Typography'

const FullWidthBox = styled(Box)`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
`

const Footer = () => (
  <FullWidthBox bgcolor="primary.main" mt={8}>
    <Grid container justifyContent="space-between" alignItems="center" px={2} sx={{ textAlign: 'center' }}>
      <Grid
        direction="column"
        container
        item
        alignSelf="center"
        alignItems="center"
        justifyContent="center"
        pt={2}
        pb={2}
        xs={12}
        md
        sx={{ width: 'auto' }}
      >
        <Grid item>
          <Logo />
        </Grid>

        <Grid container item justifyContent="center" alignItems="center">
          <WhiteTextTypography>hello@greensparksoftware.com</WhiteTextTypography>

          <Link
            sx={{ marginLeft: '8px', display: 'flex', alignItems: 'center' }}
            target="_blank"
            color="white"
            rel="noopener"
            underline="none"
            href="https://www.linkedin.com/company/greenspark-software/"
          >
            <LinkedInIcon />
          </Link>
        </Grid>

        <Grid item>
          <WhiteTextTypography>&copy; GreenSpark Software 2021</WhiteTextTypography>
        </Grid>
      </Grid>

      <Grid item xs={12} md sx={{ textAlign: 'center' }}>
        <img alt="ISRI membership icon" src={ISRILogo} />
      </Grid>
    </Grid>
  </FullWidthBox>
)

export default Footer
